export default class CustomError extends Error {
  constructor(errNro, message) {
    super(errNro, message);

    this.errNro = errNro;
    this.message = message;
  }
}


// WEBPACK FOOTER //
// ./src/utils/CustomError.js